/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProofOfPayment
 */
export interface ProofOfPayment {
    /**
     * 
     * @type {string}
     * @memberof ProofOfPayment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProofOfPayment
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof ProofOfPayment
     */
    image: string;
}

/**
 * Check if a given object implements the ProofOfPayment interface.
 */
// @ts-ignore
export function instanceOfProofOfPayment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "orderId" in value;
    isInstance = isInstance && "image" in value;

    return isInstance;
}

// @ts-ignore
export function ProofOfPaymentFromJSON(json: any): ProofOfPayment {
    return ProofOfPaymentFromJSONTyped(json, false);
}

// @ts-ignore
export function ProofOfPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProofOfPayment {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderId': json['order_id'],
        'image': json['image'],
    };
}

// @ts-ignore
export function ProofOfPaymentToJSON(value?: ProofOfPayment | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order_id': value.orderId,
        'image': value.image,
    };
}

